import { Injectable } from "@angular/core";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import * as AWS from "aws-sdk/global";
import * as awsservice from "aws-sdk/lib/service";
import * as CognitoIdentity from "aws-sdk/clients/cognitoidentity";
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
    handleMFAStep?(challengeName: string, challengeParameters: ChallengeParameters, callback: (confirmationCode: string) => any): void;
}

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface ChallengeParameters {
    CODE_DELIVERY_DELIVERY_MEDIUM: string;
    CODE_DELIVERY_DESTINATION: string;
}

export interface Callback {
    callback(): void;

    callbackWithParam(result: any): void;
}


export interface CognitoUtilConfig {
    region: string;
    identityPoolId: string;
    userPoolId: string;
    clientId: string;
    endpoint?: string; // Optional custom endpoint
  }

@Injectable()
export class CognitoUtil {
    private config: CognitoUtilConfig;
    public  _REGION;
    public  _IDENTITY_POOL_ID;
    public  _USER_POOL_ID;
    public  _CLIENT_ID;
    constructor(config: CognitoUtilConfig) {
        this.config = config;
        this._REGION = config.region;
        this._IDENTITY_POOL_ID = config.identityPoolId
        this._USER_POOL_ID = config.userPoolId;
        this._CLIENT_ID = config.clientId;
    }
    

    public get poolData(): { UserPoolId: string; ClientId: string } {
        return {
          UserPoolId: this._USER_POOL_ID,
          ClientId: this._CLIENT_ID,
        };
      }

    public cognitoCreds: AWS.CognitoIdentityCredentials;

    public getUserPool(): CognitoUserPool {
        const poolData: any = {
          UserPoolId: this._USER_POOL_ID,
          ClientId: this._CLIENT_ID
        };
    
        if (EnvironmentLoader.environment.cognito_idp_endpoint) {
          poolData.endpoint = EnvironmentLoader.environment.cognito_idp_endpoint;
        }
    
        return new CognitoUserPool(poolData);
      }

    getCurrentUser() {
        return this.getUserPool().getCurrentUser();
    }

    // AWS Stores Credentials in many ways, and with TypeScript this means that
    // getting the base credentials we authenticated with from the AWS globals gets really murky,
    // having to get around both class extension and unions. Therefore, we're going to give
    // developers direct access to the raw, unadulterated CognitoIdentityCredentials
    // object at all times.
    setCognitoCreds(creds: AWS.CognitoIdentityCredentials) {
        this.cognitoCreds = creds;
    }

    getCognitoCreds() {
        return this.cognitoCreds;
    }

    // This method takes in a raw jwtToken and uses the global AWS config options to build a
    // CognitoIdentityCredentials object and store it for us. It also returns the object to the caller
    // to avoid unnecessary calls to setCognitoCreds.
    buildCognitoCreds(idTokenJwt: string) {
        let url = 'cognito-idp.' + this._REGION.toLowerCase() + '.amazonaws.com/' + this._USER_POOL_ID;
        if (EnvironmentLoader.environment.cognito_idp_endpoint) {
            url = EnvironmentLoader.environment.cognito_idp_endpoint + '/' + this._USER_POOL_ID;
        }
        let logins: CognitoIdentity.LoginsMap = {};
        logins[url] = idTokenJwt;
        let params = {
            IdentityPoolId: this._IDENTITY_POOL_ID, /* required */
            Logins: logins
        };
        let serviceConfigs = <awsservice.ServiceConfigurationOptions>{};
        if (EnvironmentLoader.environment.cognito_identity_endpoint) {
            serviceConfigs.endpoint = EnvironmentLoader.environment.cognito_identity_endpoint;
        }
        let creds = new AWS.CognitoIdentityCredentials(params, serviceConfigs);
        this.setCognitoCreds(creds);
        return creds;
    }
}
